export const SIGNUP_INVITE_PARAM = "invite";

export const SIGNUP_INVITE = {
  ADMIN: "admin",
  PRACTICE: "practice",
  PRACTICE_PRO: "practice_pro",
} as const;

export type SignupInvite = (typeof SIGNUP_INVITE)[keyof typeof SIGNUP_INVITE];

const PRACTICE_INVITES: string[] = [
  SIGNUP_INVITE.PRACTICE,
  SIGNUP_INVITE.PRACTICE_PRO,
];

const V1_INVITES: string[] = [SIGNUP_INVITE.ADMIN, ...PRACTICE_INVITES];

export const isV1SignupInvite = (invite: string | null): boolean =>
  Boolean(invite) && V1_INVITES.includes(invite as string);

export const isPracticeSignupInvite = (invite: string | null): boolean =>
  Boolean(invite) && PRACTICE_INVITES.includes(invite as string);
